export class Log {
    constructor(
        public name: string,
        public level: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/logs/log.model.ts